import React from 'react';
import { IconBulletList } from '../../../icons';
import { FormattedMessage } from '../../../util/reactIntl';

import css from '../MapWithGoogleMap.css';
import Button from '../../Button/Button';
/** icon-bullet-list-l */
/** icon-bullet-list */
export default ({ onClose = () => null }) => (
    <Button className={css.searchPanelCloseControlMob} onClick={onClose}>
        <IconBulletList />
        <FormattedMessage id="SearchMap.closeButtonLabel" />
    </Button>
);
